"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { FiPlus, FiX } from "react-icons/fi";
import { headerNavLinks } from "@/data/navigation";
import { siteConfig } from "@/data/common/site";
import Button from "@/components/ui/Button";

export default function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  const handleMobileNavClick = (href: string, e: React.MouseEvent<HTMLAnchorElement>) => {
    setIsOpen(false);
    if (href.includes("#equipments") && pathname === "/capabilities") {
      e.preventDefault();
      const el = document.getElementById("equipments");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.pushState(null, "", "/capabilities#equipments");
      }
    }
  };

  return (
    <div className="lg:hidden">
      {/* Mobile Trigger Button: + Menu */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
        className="inline-flex items-center gap-1.5 sm:gap-2 text-white font-poppins font-normal text-sm sm:text-base hover:text-brand-cream transition-colors duration-200 py-1.5 px-2 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-green min-h-[44px]"
      >
        {isOpen ? (
          <FiX size={20} className="shrink-0 text-white" aria-hidden="true" />
        ) : (
          <FiPlus size={20} className="shrink-0 text-white" aria-hidden="true" />
        )}
        <span className="font-medium tracking-wide">{isOpen ? "Close" : "Menu"}</span>
      </button>

      {/* Dropdown Menu: Identical glass effect, matches exact header width */}
      {isOpen && (
        <div className="absolute left-0 right-0 top-[calc(100%+10px)] w-full bg-brand-dark/85 backdrop-blur-md rounded-header border border-white/10 shadow-2xl p-6 flex flex-col gap-4 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
          <nav aria-label="Mobile navigation">
            <ul className="flex flex-col gap-2 m-0 p-0 list-none">
              {headerNavLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    href={item.href}
                    onClick={(e) => handleMobileNavClick(item.href, e)}
                    className="block font-poppins text-base sm:text-lg text-white hover:text-brand-cream py-2.5 px-3 rounded hover:bg-white/5 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="pt-3 border-t border-white/10">
            <Button
              href={siteConfig.cta.href}
              icon={<FiPlus size={20} />}
              className="w-full justify-center"
              onClick={() => setIsOpen(false)}
            >
              {siteConfig.cta.label}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
